//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { colorsValues as SF_COLORS } from "../../../../styles/variables/colors";
import SfIcon from "../../atoms/SfIcon/SfIcon.vue";
import SfPrice from "../../atoms/SfPrice/SfPrice.vue";
import SfBadge from "../../atoms/SfBadge/SfBadge.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import { getCMSLabels } from '~/helpers/globalLabels';
import SfLoader from '../../atoms/SfLoader/SfLoader.vue';
import { imagePlaceholderProduct } from "~/common";
import { handleImageError } from "~/common";
import useProductMixin from '@/mixins/product';
import { coveoGetters } from "~/composables/getters";
import { useUserStore } from '~/stores/user-store';
import { getImage } from "~/composables/getters/bloomreachGetters";

export default {
  name: "SfProductCard",
  components: {
    SfPrice,
    SfIcon,
    SfBadge,
    SfButton,
    SfLoader
},
  props: {
    productName: {
      type: [Number, String],
      default: null,
    },
    productId: {
      type: [Number, String],
      default: null,
    },
    image: {
      type: [Array, Object, String],
      default: imagePlaceholderProduct,
    },
    imageWidth: {
      type: [Number, String],
      default: '240px',
    },
    imageHeight: {
      type: [Number, String],
      default: '240px',
    },
    badgeLabel: {
      type: String,
      default: "",
    },
    customBadgeColor: {
      type: String,
      default: "var(--c-secondary-turquoise)",
    },
    badgeColor: {
      type: String,
      default: "",
    },
    colors: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    link: {
      type: [String, Object],
      default: "",
    },
    /**
     * Link element tag
     * @deprecated will be removed in 1.0.0 use slot to replace content
     */
    linkTag: {
      type: String,
      default: undefined,
    },
    regularPrice: {
      type: [Number, String],
      default: null,
    },
    specialPrice: {
      type: [Number, String],
      default: null,
    },
    lowestPrice: {
      type: [Number, String],
      default: null,
    },
    showAddToCartButton: {
      type: Boolean,
      default: true,
    },
    isAddedToCart: {
      type: Boolean,
      deafult: false,
    },
    imageTag: {
      type: String,
      default: "",
    },
    nuxtImgConfig: {
      type: Object,
      default: () => ({}),
    },
    product: Object,
    onlyAvailableTo: String,
    isProductHasExcusivePrice: Boolean,
    isOnDiscount: Boolean,
  },
  data() {
    return {
      openColorPicker: false,
    };
  },
  computed: {
    isSFColors() {
      return SF_COLORS.includes(this.badgeColor.trim());
    },
    showBadge() {
      return this.colors.length > 5;
    },
    addToCartDisabled() {
      return coveoGetters.disableAddToCart(this.product?.inStock, this.product?.regularPrice);
    },
    exclusivePriceBadge() {
      const isUserLoggedIn = this.userStore.getUserIsLoggedIn;
      const hasExclusivePrice = isUserLoggedIn ? this.isProductHasExcusivePrice : !this.isOnDiscount &&  this.isProductHasExcusivePrice;
      
      if (hasExclusivePrice) {
        const discountPrice = isUserLoggedIn
          ? '' // Logged-in user
          : this.$n(coveoGetters.getProductExclusivePrices(this.product).discount_price, 'currency');

        const exclusivePriceLabelText = getCMSLabels('my-moomin-price') || 'MyMoomin Price (hardcoded)';

        return `${exclusivePriceLabelText}${isUserLoggedIn ? '' : `: ${discountPrice}`}`;
      }

      // No exclusive price
      return '';
    },
    getSpecialPrice() {
      if (this.isProductHasExcusivePrice && this.userStore.getUserIsLoggedIn) {
        return this.$n(coveoGetters.getProductExclusivePrices(this.product).discount_price, 'currency');
      }
      return this.specialPrice
    },
    badgeLabelDisplay(){
      return this.onlyAvailableTo || this.badgeLabel?'' :'display-none'
    },
    getImageAlt() {
      return `${this.title} - ${this.product.excerpt}`;
    },
    getProductAriaLabel() {
      const productLabel = this.$t("buttons.go-to-product", { product: this.title });

      if (this.getSpecialPrice !== this.regularPrice) {
        return `${productLabel} ${this.$t("special-price")} ${this.getSpecialPrice} ${this.$t("regular-price")} ${this.regularPrice}`;
      } else if (this.regularPrice) {
        return `${productLabel} ${this.regularPrice}`;
      }

      return productLabel;
    }
  },
  setup(props) {
    const userStore = useUserStore();
    const mixinData = {
      onlyAvailableTo: props.onlyAvailableTo,
      isOutOfStock: coveoGetters.disableAddToCart(props.product?.inStock, props.product?.regularPrice),
      product: props.product,
      isListingPage: true
    }

    const { getAddToCartButtonText, addItem, showLoader, initiatingCart ,getExclusiveProductText} = useProductMixin(mixinData);

    return {
      addItem,
      showLoader,
      initiatingCart,
      handleImageError,
      getAddToCartButtonText,
      getExclusiveProductText,
      userStore
    }
  },
  methods: {
    getLowestPriceLabel() {
      return getCMSLabels('lowestprice');
    },
    getButtonText(isDisabled) {
      const addToCartLabel = getCMSLabels('addtocart');
      const disabledLabel = getCMSLabels('get-notified');
      return isDisabled ? disabledLabel : addToCartLabel;
    },
  },
};
